var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLeftArrowMobile = function SvgLeftArrowMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.339,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#BBCCD4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.492c.006.601.248 1.176.674 1.6l4.903 4.914a1.143 1.143 0 1 0 1.612-1.622l-3.76-3.749h11.428a1.143 1.143 0 0 0 0-2.286H11.43l3.76-3.76a1.143 1.143 0 1 0-1.612-1.623l-4.903 4.915A2.286 2.286 0 0 0 8 16.492Z",
    fill: "#053249"
  })));
};
export default SvgLeftArrowMobile;